import { VIEWPORT_W } from './constants';

/** HUD in viewport space (scrollFactor 0). Matches main game layout.js HUD. */
export const HUD = {
  paddingTop: 36,
  paddingSide: 60,
  labelSize: 26,
  energyValueSize: 88,
  dustValueSize: 52,
  dustIconSize: 120,
  dustGap: 15,
  regenSize: 36,
  backpack: { x: 88, y: 88, iconH: 140, gap: 20 },
  equipment: { right: 20, top: 140, slot: 240, gap: 15 },
};

export const EQUIP_UI = {
  slot: HUD.equipment.slot,
  gap: HUD.equipment.gap,
};

/** Design-time energy/dust row Y — prefer hud-viewport.hudEnergyColumnY() on device. */
export function hudEnergyColumnY() {
  return HUD.paddingTop + HUD.labelSize + HUD.energyValueSize * 0.5;
}

/** Design-time slot positions — prefer hud-viewport.equipmentSlotPosition() on device. */
export function equipmentSlotPosition(index: number) {
  const x = VIEWPORT_W - HUD.equipment.right - EQUIP_UI.slot;
  const y = HUD.equipment.top;
  return {
    x,
    y: y + index * (EQUIP_UI.slot + EQUIP_UI.gap),
    size: EQUIP_UI.slot,
  };
}
